// Sourced from ETG "Best Practices for APIv3" (Jan 2025) and the RateHawk
// OpenAPI spec. Kept as named constants so swapping the mock layer for the
// real API is a config change, not a rewrite.

export const SEARCH_TIMEOUT_SECONDS = 30; // SERP / Hotelpage recommended timeout
export const PREBOOK_TIMEOUT_SECONDS = 60; // recommended; ETG-side only, not sent by us
export const PREBOOK_MIN_TIMEOUT_SECONDS = 30;

export const MAX_ROOMS_PER_RATE = 9;
export const MAX_ADULTS_PER_ROOM = 6;
export const MAX_CHILDREN_PER_ROOM = 4;
export const CHILD_MAX_AGE = 17;
export const MAX_STAY_NIGHTS = 30;
export const MAX_CHECKIN_DAYS_AHEAD = 730;

// Order Booking Form: retry with a *new* partner_order_id on timeout/unknown/5xx.
// Reusing the same id throws "double_booking_form".
export const MAX_BOOKING_FORM_RETRIES = 10;

// Check booking process (booking/finish/status): recommended poll cadence
// while status is "processing" — verified against live docs 2026-08-10.
export const CHECK_BOOKING_POLL_INTERVAL_SECONDS = 5;

export const MOCK_NETWORK_DELAY_MS = 400;
